import React from 'react';
import PropTypes from 'prop-types';
import systemMessageModule from './SystemMessage.module.scss';

function SystemMessage(props) {
  return <div className={systemMessageModule.SystemMessageContainer}>
    <div style={window.sutherland_variables.ui.system_message}>
      {props.message.text}
    </div>
  </div>;
}

SystemMessage.propTypes = {
  message: PropTypes.object,
};

export default SystemMessage;